module.exports = __webpack_public_path__ + "static/media/alexandrina_dinga.d8e4813f.png";